export default __webpack_public_path__ + "static/media/section1.2502b402.png";